import React from "react";
import {ModalHeader} from "reactstrap";
import PropTypes from "prop-types";

export default class ModalCardHeader extends React.Component{

    render() {
        let {content, onClick, style} = this.props
        if(!onClick){
            onClick = () => {}
        }
        return (
            <ModalHeader
                className="bg-header w-100 d-block"
                style={style}
                onClick={(e)=>{
                    onClick(e)
                }}>
                {content}
            </ModalHeader>
        );
    }

}

ModalCardHeader.propTypes={
    content: PropTypes.any.isRequired,
    onClick: PropTypes.func,
    style: PropTypes.any
}
